import { memoryOperations } from "@/datastore/memory";
import { ActiveMemory } from "@/memory/types";
import { UISDK } from "@/ui-sdk";
import { cultureCircleDefaultMemory } from "@/ui-sdk/components/static/default-memory/cc";

export default async function handleMemoryRecommendation(
  element: HTMLElement,
  sdk: UISDK,
) {
  let id = "";
  let subcategory = "";
  let memoryData = {} as ActiveMemory;
  const orgId = window?.helium?.brandData?.orgId;
  const storeId = window?.helium?.brandData?.storeId || "";
  const userId = window?.helium?.userToken || localStorage.getItem("userToken");

  const cleanMemoryData = (memoryData: ActiveMemory) => {
    let filteredData: Record<string, any> = {};

    for (let category in memoryData) {
      let details = memoryData[category];
      if (
        details.behavioral?.preferences?.visual &&
        Object.keys(details.behavioral.preferences.visual).length > 0
      ) {
        filteredData[category] = details;
      }
    }

    return filteredData;
  };

  if (window.location.pathname.includes("products")) {
    id = window.location.pathname.split("/").at(-1) as string;

    subcategory = await window.helium.datastore.getTags({ id }).then((res) => {
      return res?.subcategory;
    });
    memoryData = memoryOperations.get();
    if (
      !memoryData[subcategory?.toLowerCase()]?.behavioral?.preferences?.visual
    ) {
      const result =
        await fetch(`https://analytics.heliumbuilder.com/memory?orgId=${orgId}&storeId=${storeId}&userId=${userId}
    `);

      const previousRecommendation = await result.json();
      if (previousRecommendation.name == "TypeError") return;
      memoryData = previousRecommendation;
    }
  } else {
    if (
      window.helium.brandData.orgId == "culture-circle" &&
      window.location.pathname.includes("/checkout") &&
      (!memoryData ||
        !Object.keys(memoryData).length ||
        !memoryData[Object.keys(memoryData)[0]]?.behavioral?.preferences
          ?.visual)
    ) {
      memoryData = cultureCircleDefaultMemory;
    } else {
      const result =
        await fetch(`https://analytics.heliumbuilder.com/memory?orgId=${orgId}&storeId=${storeId}&userId=${userId}
      `);
      const previousRecommendation = await result.json();
      if (previousRecommendation.name == "TypeError") {
        memoryData = cleanMemoryData(memoryOperations.get());
      } else {
        memoryData = cleanMemoryData(previousRecommendation);
      }
    }
  }

  return sdk.renderMemoryRecommentaion(element, subcategory, memoryData);
}
